// Google Analytics utility with consent mode support

// Get Google Analytics ID from environment variables (fallback for security)
const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || 'G-496299203';

// Initialize Google Analytics with consent mode
export const initializeGoogleAnalytics = () => {
    // Add Google Analytics script if not already present
    if (!window.gtag) {
        // Create gtag script
        const script1 = document.createElement('script');
        script1.async = true;
        script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
        document.head.appendChild(script1);

        // Initialize gtag function
        window.dataLayer = window.dataLayer || [];
        function gtag(){window.dataLayer.push(arguments);}
        window.gtag = gtag;

        // Set default consent mode (denied by default for GDPR compliance)
        gtag('consent', 'default', {
            'analytics_storage': 'denied',
            'ad_storage': 'denied',
            'wait_for_update': 500
        });

        // Initialize Google Analytics
        gtag('js', new Date());
        gtag('config', GA_MEASUREMENT_ID, {
            'anonymize_ip': true,
            'cookie_flags': 'SameSite=None;Secure'
        });
    }
};

// Update consent based on user preferences
export const updateAnalyticsConsent = (analyticsEnabled) => {
    if (window.gtag) {
        window.gtag('consent', 'update', {
            'analytics_storage': analyticsEnabled ? 'granted' : 'denied'
        });
    }
};

// Remove Google Analytics cookies when consent is withdrawn
export const removeAnalyticsCookies = () => {
    const cookies = document.cookie.split(';');
    const domain = window.location.hostname;
    
    cookies.forEach(cookie => {
        const eqPos = cookie.indexOf('=');
        const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
        
        if (name.startsWith('_ga') || name.startsWith('_gid') || name.startsWith('_gat')) {
            // Remove cookie for current path
            document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
            
            // Remove cookie for domain
            document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=.${domain}`;
            
            // Remove cookie for parent domain (if subdomain)
            if (domain.includes('.')) {
                const parentDomain = domain.substring(domain.indexOf('.'));
                document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${parentDomain}`;
            }
        }
    });
};

// Check if user has already consented
export const hasConsentedToAnalytics = () => {
    const consent = localStorage.getItem('cookieConsent');
    if (consent) {
        const preferences = JSON.parse(consent);
        return preferences.analytics === true;
    }
    return false;
};

// Initialize analytics only if user has consented
export const conditionallyInitializeAnalytics = () => {
    initializeGoogleAnalytics();
    
    const hasConsented = hasConsentedToAnalytics();
    updateAnalyticsConsent(hasConsented);
    
    if (!hasConsented) {
        removeAnalyticsCookies();
    }
};

// GDPR-compliant event tracking
export const trackEvent = (eventName, parameters = {}) => {
    if (hasConsentedToAnalytics() && window.gtag) {
        window.gtag('event', eventName, {
            ...parameters,
            'send_to': GA_MEASUREMENT_ID
        });
    }
};

// Track page views (GDPR compliant)
export const trackPageView = (pagePath, pageTitle) => {
    if (hasConsentedToAnalytics() && window.gtag) {
        window.gtag('config', GA_MEASUREMENT_ID, {
            'page_path': pagePath,
            'page_title': pageTitle
        });
    }
}; 